import axios from 'axios';
import qs from 'qs';
import { api } from '../../app/conf';

export const signInService = (username, password) => axios({
    method: 'post',
    url: `${api}/access`,
    data: qs.stringify({
        username,
        password
    })
});
